import Alpine from "alpinejs";
import focus from "@alpinejs/focus";

Alpine.plugin(focus);
// Make Alpine available globally
window.Alpine = Alpine;

// Start Alpine
Alpine.start();
